
export interface ProviderDetails {
  id: number;
  active: boolean;
  providerTypeId: number;
  addressStreet: string | null;
  addressLineTwo: string | null;
  addressCity: string | null;
  addressState: string | null;
  addressZip: string | null;
  addressPlaceId: string | null;
  teams: number[];
  gender: string;
  languages: string[];
  licensedStates: string[];
  external: boolean;
  identifier: string | null;
}

export interface UserDetails {
  email: string;
  firstName: string;
  lastName: string;
  deleted: boolean;
  organizationalUnits: number[];
  serviceLines: number[];
  roles: number[];
  provider: ProviderDetails;
  userIsProvider: boolean; // computed field true if the provider.active is true or if the provider.id is set and the user is not deleted
}

export interface UserDropDownOptions {
  roles: { name: string; id: number }[];
  providerTypes: { name: string; id: number }[];
  organizationalUnits: { name: string; id: number; active: boolean }[];
  serviceLines: { name: string; id: number }[];
  teams: { name: string; id: number }[];
  genders: { label: string; value: string }[];
  languages: { label: string; value: string }[];
  states: { label: string; value: string }[];
  licensableProviderTypes: string[];
}

export const DEFAULT_PROVIDER_DETAILS: ProviderDetails = {
  id: 0,
  active: false,
  providerTypeId: 0,
  addressStreet: "",
  addressLineTwo: "",
  addressCity: "",
  addressState: "",
  addressZip: "",
  addressPlaceId: null,
  teams: [],
  gender: "",
  languages: [],
  licensedStates: [],
  external: false,
  identifier: "",
};

export const DEFAULT_USER_DETAILS: UserDetails = {
  deleted: false,
  email: "",
  firstName: "",
  organizationalUnits: [],
  serviceLines: [],
  lastName: "",
  roles: [],
  provider: DEFAULT_PROVIDER_DETAILS,
  userIsProvider: false,
};
